module.exports = __webpack_public_path__ + "static/media/DBKFoundryDiningHallA0014_design_clean_v002.8c11c3db.png";